<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table [request]="getRequest" [cols]="cols" [filtering]="filtering"
        [globalConditionalStyle]="globalConditionalStyle" [globalVisualTransform]="globalVisualTransform"
        [showExportCsv]="showCostesTareasOtrasCsv" (emitSearchText)="updateFooter()">
        <ng-template #header let-data>
            <div 
                style="width: 100%; margin-right: 15px" 
                class="d-flex justify-content-center align-items-center" 
                *ngIf="appName === 'tomega' || appName === 'detorres'">
                <div style="margin-left: 10px; margin-right: 10px">
                    <div style="font-size: 0.7em" class="btn-group">
                        <button 
                            *ngIf="appName === 'detorres'"
                            type="button" 
                            class="btn btn-info me-4" 
                            style="padding: 5px; font-size: .8rem; border: none; background-color: #16A2B7; color: white; width: 10rem;"
                            (click)="generateMachineryReport()">Informe Maquinaria</button>

                        <button 
                            type="button" 
                            class="btn btn-info" 
                            style="padding: 5px; font-size: .8rem; border: none; background-color: #16A2B7; color: white; width: 10rem;"
                            (click)="show('generate', this.model)">Informe Trabajador</button>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #thEnd>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                [hideEdit]="true" [hideDelete]="true"
                    (deleteRowButtonEvent)="show('delete', data.data)" (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        </ng-template>

        <ng-template #footer let-col>
            <div style="font-size: 0.75em; text-align: left" *ngIf="(['finca'].includes(col.field))">
                TOTAL:
            </div>
            <div style="font-size: 0.75em; text-align: center; font-weight: bold">
                <span
                    *ngIf="(['coste','precio_total','coste_total','maquinaria_precio_total','coste_subcontrata'].includes(col.field))">
                    {{moneyFormat(col.footer)}} €
                </span>
                <span *ngIf="(['cantidad', 'horas'].includes(col.field))">
                    {{decimalFormat(col.footer,2,'.',',',3)}}
                </span>
            </div>
        </ng-template>

    </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
    <ng-template #afterFormContent>
        <app-costes-tareas-otros
            *ngIf="showTarea"
            [model]="model">
        </app-costes-tareas-otros>

        <app-costes-tareas-fitosanitarios
            *ngIf="showTareaFito"
            [model]="model">
        </app-costes-tareas-fitosanitarios>

        <app-costes-tareas-fertilizantes
            *ngIf="showTareaFerti"
            [model]="model">
        </app-costes-tareas-fertilizantes>

        <div *ngIf="appName === 'mbcpomelos'">
            <div class="d-flex justify-content-center" style="margin-top: 50px;">
                <h4>Costes de Subcontratos</h4>
            </div>

            <div class="d-flex justify-content-center">
                <table class="table-style">
                    <tr>
                        <th style="width: 25%;">Finca</th>
                        <th style="width: 25%;">Proveedor</th>
                        <th style="width: 25%;">Precio</th>
                        <th style="width: 25%;">Total</th>
                    </tr>
                    <tr>
                        <td>{{ model.finca }}</td>
                        <td style="text-align: right;">{{ model.proveedor }}</td>
                        <td style="text-align: right;">{{ moneyFormat(model.coste_subcontrata ?? 0) }} €</td>
                        <td style="text-align: right;">{{ moneyFormat(model.coste_subcontrata ?? 0) }} €</td>
                    </tr>
                </table>
            </div>
        </div>
    </ng-template>
</app-modals>

<p-dialog
    *ngIf="canShow['generate']"
    header="Generar archivo"
    [(visible)]="canShow['generate']"
    (onShow)="scrollToTop()">

    <div [ngStyle]="{'width.vw': '50'}" style="min-height: 40vw !important;">
        <div class="row">
            <div class="col-12 col-md-6 mb-3" *ngIf="appName === 'detorres'">
                <label class="form-label" for="trabajador-report">Trabajador</label>
                <p-select
                    inputId="trabajador-report"
                    class="w-100"
                    [options]="trabajadores.filtered"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="..."
                    appendTo="body"
                    [formControl]="selectedTrabajadorControl">
                </p-select>
            </div>

            <div class="col-12 col-md-6 mb-3" *ngIf="appName === 'tomega'">
                <label class="form-label" for="mes-report">Mes</label>
                <p-datePicker
                    inputId="mes-report"
                    class="w-100"
                    [formControl]="generarMesControl"
                    view="month"
                    dateFormat="mm"
                    appendTo="body">
                </p-datePicker>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="form-label" for="anyo-report">Año</label>
                <p-datePicker
                    inputId="anyo-report"
                    class="w-100"
                    [formControl]="generarAnyoControl"
                    view="year"
                    dateFormat="yy"
                    appendTo="body">
                </p-datePicker>
            </div>
        </div>

        <br>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" type="button" (click)="hide('generate')">Cerrar</button>

            <button class="btn btn-primary mx-2" type="button" (click)="generateWorkerReport()">Generar</button>
        </div>
        <br>
    </div>
</p-dialog>
